/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as UnauthenticatedRouteRouteImport } from './routes/_unauthenticated/route'
import { Route as ServerLocationWizardRouteImport } from './routes/server-location-wizard'
import { Route as AuthenticatedLayoutRouteRouteImport } from './routes/_authenticated/_layout/route'
import { Route as AuthenticatedSessionRouteRouteImport } from './routes/_authenticated/session/route'
import { Route as UnauthenticatedLegalRouteImport } from './routes/_unauthenticated/legal'
import { Route as UnauthenticatedLoginRouteImport } from './routes/_unauthenticated/login'
import { Route as UnauthenticatedPrivacyRouteImport } from './routes/_unauthenticated/privacy'
import { Route as UnauthenticatedTermsRouteImport } from './routes/_unauthenticated/terms'
import { Route as AuthenticatedLayoutMainRouteRouteImport } from './routes/_authenticated/_layout/_main/route'
import { Route as AuthenticatedSessionIndexRouteImport } from './routes/_authenticated/session/index'
import { Route as AuthenticatedSessionRemoteRenderingNodeBackchannelRouteImport } from './routes/_authenticated/session/remote-rendering-node-backchannel'
import { Route as UnauthenticatedOauth2CallbackRouteImport } from './routes/_unauthenticated/oauth2/callback'
import { Route as AuthenticatedLayoutMainIndexRouteImport } from './routes/_authenticated/_layout/_main/index'
import { Route as AuthenticatedLayoutMainCenteredRouteRouteImport } from './routes/_authenticated/_layout/_main/_centered/route'
import { Route as AuthenticatedLayoutMainCenteredConnectDeviceRouteImport } from './routes/_authenticated/_layout/_main/_centered/connect-device'
import { Route as AuthenticatedLayoutMainCenteredConnectHmdRouteImport } from './routes/_authenticated/_layout/_main/_centered/connect-hmd'
import { Route as AuthenticatedLayoutMainCenteredFlagsRouteImport } from './routes/_authenticated/_layout/_main/_centered/flags'
import { Route as AuthenticatedLayoutMainCenteredLogoutRouteImport } from './routes/_authenticated/_layout/_main/_centered/logout'
import { Route as AuthenticatedLayoutMainAppsAppIdRouteImport } from './routes/_authenticated/_layout/_main/apps/$appId'
import { Route as AuthenticatedLayoutMainCenteredInstallClientIndexRouteImport } from './routes/_authenticated/_layout/_main/_centered/install-client/index'
import { Route as AuthenticatedLayoutMainCenteredEventsEventIdRsvpRouteImport } from './routes/_authenticated/_layout/_main/_centered/events/$eventId/rsvp'
import { Route as AuthenticatedLayoutMainCenteredInstallClientDeviceSlugChar123InstallationTypeChar125RouteImport } from './routes/_authenticated/_layout/_main/_centered/install-client/$deviceSlug.{-$installationType}'
import { Route as AuthenticatedLayoutMainGroupsGroupIdAppsAppIdRouteImport } from './routes/_authenticated/_layout/_main/groups/$groupId/apps/$appId'
import { Route as AuthenticatedLayoutMainCenteredAppsAppIdLaunchIndexRouteImport } from './routes/_authenticated/_layout/_main/_centered/apps/$appId/launch.index'
import { Route as AuthenticatedLayoutMainCenteredAppsAppIdLaunchRenderModeTargetDeviceTypeRouteImport } from './routes/_authenticated/_layout/_main/_centered/apps/$appId/launch.$renderMode.$targetDeviceType'
import { Route as AuthenticatedLayoutMainCenteredGroupsGroupIdAppsAppIdLaunchIndexRouteImport } from './routes/_authenticated/_layout/_main/_centered/groups/$groupId/apps/$appId/launch.index'
import { Route as AuthenticatedLayoutMainCenteredGroupsGroupIdAppsAppIdLaunchRenderModeTargetDeviceTypeRouteImport } from './routes/_authenticated/_layout/_main/_centered/groups/$groupId/apps/$appId/launch.$renderMode.$targetDeviceType'

const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const UnauthenticatedRouteRoute = UnauthenticatedRouteRouteImport.update({
  id: '/_unauthenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const ServerLocationWizardRoute = ServerLocationWizardRouteImport.update({
  id: '/server-location-wizard',
  path: '/server-location-wizard',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedLayoutRouteRoute =
  AuthenticatedLayoutRouteRouteImport.update({
    id: '/_layout',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSessionRouteRoute =
  AuthenticatedSessionRouteRouteImport.update({
    id: '/session',
    path: '/session',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const UnauthenticatedLegalRoute = UnauthenticatedLegalRouteImport.update({
  id: '/legal',
  path: '/legal',
  getParentRoute: () => UnauthenticatedRouteRoute,
} as any)
const UnauthenticatedLoginRoute = UnauthenticatedLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => UnauthenticatedRouteRoute,
} as any)
const UnauthenticatedPrivacyRoute = UnauthenticatedPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => UnauthenticatedRouteRoute,
} as any)
const UnauthenticatedTermsRoute = UnauthenticatedTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => UnauthenticatedRouteRoute,
} as any)
const AuthenticatedLayoutMainRouteRoute =
  AuthenticatedLayoutMainRouteRouteImport.update({
    id: '/_main',
    getParentRoute: () => AuthenticatedLayoutRouteRoute,
  } as any)
const AuthenticatedSessionIndexRoute =
  AuthenticatedSessionIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSessionRouteRoute,
  } as any)
const AuthenticatedSessionRemoteRenderingNodeBackchannelRoute =
  AuthenticatedSessionRemoteRenderingNodeBackchannelRouteImport.update({
    id: '/remote-rendering-node-backchannel',
    path: '/remote-rendering-node-backchannel',
    getParentRoute: () => AuthenticatedSessionRouteRoute,
  } as any)
const UnauthenticatedOauth2CallbackRoute =
  UnauthenticatedOauth2CallbackRouteImport.update({
    id: '/oauth2/callback',
    path: '/oauth2/callback',
    getParentRoute: () => UnauthenticatedRouteRoute,
  } as any)
const AuthenticatedLayoutMainIndexRoute =
  AuthenticatedLayoutMainIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedLayoutMainRouteRoute,
  } as any)
const AuthenticatedLayoutMainCenteredRouteRoute =
  AuthenticatedLayoutMainCenteredRouteRouteImport.update({
    id: '/_centered',
    getParentRoute: () => AuthenticatedLayoutMainRouteRoute,
  } as any)
const AuthenticatedLayoutMainCenteredConnectDeviceRoute =
  AuthenticatedLayoutMainCenteredConnectDeviceRouteImport.update({
    id: '/connect-device',
    path: '/connect-device',
    getParentRoute: () => AuthenticatedLayoutMainCenteredRouteRoute,
  } as any)
const AuthenticatedLayoutMainCenteredConnectHmdRoute =
  AuthenticatedLayoutMainCenteredConnectHmdRouteImport.update({
    id: '/connect-hmd',
    path: '/connect-hmd',
    getParentRoute: () => AuthenticatedLayoutMainCenteredRouteRoute,
  } as any)
const AuthenticatedLayoutMainCenteredFlagsRoute =
  AuthenticatedLayoutMainCenteredFlagsRouteImport.update({
    id: '/flags',
    path: '/flags',
    getParentRoute: () => AuthenticatedLayoutMainCenteredRouteRoute,
  } as any)
const AuthenticatedLayoutMainCenteredLogoutRoute =
  AuthenticatedLayoutMainCenteredLogoutRouteImport.update({
    id: '/logout',
    path: '/logout',
    getParentRoute: () => AuthenticatedLayoutMainCenteredRouteRoute,
  } as any)
const AuthenticatedLayoutMainAppsAppIdRoute =
  AuthenticatedLayoutMainAppsAppIdRouteImport.update({
    id: '/apps/$appId',
    path: '/apps/$appId',
    getParentRoute: () => AuthenticatedLayoutMainRouteRoute,
  } as any)
const AuthenticatedLayoutMainCenteredInstallClientIndexRoute =
  AuthenticatedLayoutMainCenteredInstallClientIndexRouteImport.update({
    id: '/install-client/',
    path: '/install-client/',
    getParentRoute: () => AuthenticatedLayoutMainCenteredRouteRoute,
  } as any)
const AuthenticatedLayoutMainCenteredEventsEventIdRsvpRoute =
  AuthenticatedLayoutMainCenteredEventsEventIdRsvpRouteImport.update({
    id: '/events/$eventId/rsvp',
    path: '/events/$eventId/rsvp',
    getParentRoute: () => AuthenticatedLayoutMainCenteredRouteRoute,
  } as any)
const AuthenticatedLayoutMainCenteredInstallClientDeviceSlugChar123InstallationTypeChar125Route =
  AuthenticatedLayoutMainCenteredInstallClientDeviceSlugChar123InstallationTypeChar125RouteImport.update(
    {
      id: '/install-client/$deviceSlug/{-$installationType}',
      path: '/install-client/$deviceSlug/{-$installationType}',
      getParentRoute: () => AuthenticatedLayoutMainCenteredRouteRoute,
    } as any,
  )
const AuthenticatedLayoutMainGroupsGroupIdAppsAppIdRoute =
  AuthenticatedLayoutMainGroupsGroupIdAppsAppIdRouteImport.update({
    id: '/groups/$groupId/apps/$appId',
    path: '/groups/$groupId/apps/$appId',
    getParentRoute: () => AuthenticatedLayoutMainRouteRoute,
  } as any)
const AuthenticatedLayoutMainCenteredAppsAppIdLaunchIndexRoute =
  AuthenticatedLayoutMainCenteredAppsAppIdLaunchIndexRouteImport.update({
    id: '/apps/$appId/launch/',
    path: '/apps/$appId/launch/',
    getParentRoute: () => AuthenticatedLayoutMainCenteredRouteRoute,
  } as any)
const AuthenticatedLayoutMainCenteredAppsAppIdLaunchRenderModeTargetDeviceTypeRoute =
  AuthenticatedLayoutMainCenteredAppsAppIdLaunchRenderModeTargetDeviceTypeRouteImport.update(
    {
      id: '/apps/$appId/launch/$renderMode/$targetDeviceType',
      path: '/apps/$appId/launch/$renderMode/$targetDeviceType',
      getParentRoute: () => AuthenticatedLayoutMainCenteredRouteRoute,
    } as any,
  )
const AuthenticatedLayoutMainCenteredGroupsGroupIdAppsAppIdLaunchIndexRoute =
  AuthenticatedLayoutMainCenteredGroupsGroupIdAppsAppIdLaunchIndexRouteImport.update(
    {
      id: '/groups/$groupId/apps/$appId/launch/',
      path: '/groups/$groupId/apps/$appId/launch/',
      getParentRoute: () => AuthenticatedLayoutMainCenteredRouteRoute,
    } as any,
  )
const AuthenticatedLayoutMainCenteredGroupsGroupIdAppsAppIdLaunchRenderModeTargetDeviceTypeRoute =
  AuthenticatedLayoutMainCenteredGroupsGroupIdAppsAppIdLaunchRenderModeTargetDeviceTypeRouteImport.update(
    {
      id: '/groups/$groupId/apps/$appId/launch/$renderMode/$targetDeviceType',
      path: '/groups/$groupId/apps/$appId/launch/$renderMode/$targetDeviceType',
      getParentRoute: () => AuthenticatedLayoutMainCenteredRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedLayoutMainIndexRoute
  '/$': typeof SplatRoute
  '/server-location-wizard': typeof ServerLocationWizardRoute
  '/session': typeof AuthenticatedSessionRouteRouteWithChildren
  '/legal': typeof UnauthenticatedLegalRoute
  '/login': typeof UnauthenticatedLoginRoute
  '/privacy': typeof UnauthenticatedPrivacyRoute
  '/terms': typeof UnauthenticatedTermsRoute
  '/session/remote-rendering-node-backchannel': typeof AuthenticatedSessionRemoteRenderingNodeBackchannelRoute
  '/oauth2/callback': typeof UnauthenticatedOauth2CallbackRoute
  '/session/': typeof AuthenticatedSessionIndexRoute
  '/connect-device': typeof AuthenticatedLayoutMainCenteredConnectDeviceRoute
  '/connect-hmd': typeof AuthenticatedLayoutMainCenteredConnectHmdRoute
  '/flags': typeof AuthenticatedLayoutMainCenteredFlagsRoute
  '/logout': typeof AuthenticatedLayoutMainCenteredLogoutRoute
  '/apps/$appId': typeof AuthenticatedLayoutMainAppsAppIdRoute
  '/install-client/': typeof AuthenticatedLayoutMainCenteredInstallClientIndexRoute
  '/events/$eventId/rsvp': typeof AuthenticatedLayoutMainCenteredEventsEventIdRsvpRoute
  '/install-client/$deviceSlug/{-$installationType}': typeof AuthenticatedLayoutMainCenteredInstallClientDeviceSlugChar123InstallationTypeChar125Route
  '/groups/$groupId/apps/$appId': typeof AuthenticatedLayoutMainGroupsGroupIdAppsAppIdRoute
  '/apps/$appId/launch/': typeof AuthenticatedLayoutMainCenteredAppsAppIdLaunchIndexRoute
  '/apps/$appId/launch/$renderMode/$targetDeviceType': typeof AuthenticatedLayoutMainCenteredAppsAppIdLaunchRenderModeTargetDeviceTypeRoute
  '/groups/$groupId/apps/$appId/launch/': typeof AuthenticatedLayoutMainCenteredGroupsGroupIdAppsAppIdLaunchIndexRoute
  '/groups/$groupId/apps/$appId/launch/$renderMode/$targetDeviceType': typeof AuthenticatedLayoutMainCenteredGroupsGroupIdAppsAppIdLaunchRenderModeTargetDeviceTypeRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthenticatedLayoutMainIndexRoute
  '/$': typeof SplatRoute
  '/server-location-wizard': typeof ServerLocationWizardRoute
  '/legal': typeof UnauthenticatedLegalRoute
  '/login': typeof UnauthenticatedLoginRoute
  '/privacy': typeof UnauthenticatedPrivacyRoute
  '/terms': typeof UnauthenticatedTermsRoute
  '/session/remote-rendering-node-backchannel': typeof AuthenticatedSessionRemoteRenderingNodeBackchannelRoute
  '/oauth2/callback': typeof UnauthenticatedOauth2CallbackRoute
  '/session': typeof AuthenticatedSessionIndexRoute
  '/connect-device': typeof AuthenticatedLayoutMainCenteredConnectDeviceRoute
  '/connect-hmd': typeof AuthenticatedLayoutMainCenteredConnectHmdRoute
  '/flags': typeof AuthenticatedLayoutMainCenteredFlagsRoute
  '/logout': typeof AuthenticatedLayoutMainCenteredLogoutRoute
  '/apps/$appId': typeof AuthenticatedLayoutMainAppsAppIdRoute
  '/install-client': typeof AuthenticatedLayoutMainCenteredInstallClientIndexRoute
  '/events/$eventId/rsvp': typeof AuthenticatedLayoutMainCenteredEventsEventIdRsvpRoute
  '/install-client/$deviceSlug/{-$installationType}': typeof AuthenticatedLayoutMainCenteredInstallClientDeviceSlugChar123InstallationTypeChar125Route
  '/groups/$groupId/apps/$appId': typeof AuthenticatedLayoutMainGroupsGroupIdAppsAppIdRoute
  '/apps/$appId/launch': typeof AuthenticatedLayoutMainCenteredAppsAppIdLaunchIndexRoute
  '/apps/$appId/launch/$renderMode/$targetDeviceType': typeof AuthenticatedLayoutMainCenteredAppsAppIdLaunchRenderModeTargetDeviceTypeRoute
  '/groups/$groupId/apps/$appId/launch': typeof AuthenticatedLayoutMainCenteredGroupsGroupIdAppsAppIdLaunchIndexRoute
  '/groups/$groupId/apps/$appId/launch/$renderMode/$targetDeviceType': typeof AuthenticatedLayoutMainCenteredGroupsGroupIdAppsAppIdLaunchRenderModeTargetDeviceTypeRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/_unauthenticated': typeof UnauthenticatedRouteRouteWithChildren
  '/$': typeof SplatRoute
  '/server-location-wizard': typeof ServerLocationWizardRoute
  '/_authenticated/_layout': typeof AuthenticatedLayoutRouteRouteWithChildren
  '/_authenticated/session': typeof AuthenticatedSessionRouteRouteWithChildren
  '/_unauthenticated/legal': typeof UnauthenticatedLegalRoute
  '/_unauthenticated/login': typeof UnauthenticatedLoginRoute
  '/_unauthenticated/privacy': typeof UnauthenticatedPrivacyRoute
  '/_unauthenticated/terms': typeof UnauthenticatedTermsRoute
  '/_authenticated/_layout/_main': typeof AuthenticatedLayoutMainRouteRouteWithChildren
  '/_authenticated/session/remote-rendering-node-backchannel': typeof AuthenticatedSessionRemoteRenderingNodeBackchannelRoute
  '/_unauthenticated/oauth2/callback': typeof UnauthenticatedOauth2CallbackRoute
  '/_authenticated/session/': typeof AuthenticatedSessionIndexRoute
  '/_authenticated/_layout/_main/_centered': typeof AuthenticatedLayoutMainCenteredRouteRouteWithChildren
  '/_authenticated/_layout/_main/': typeof AuthenticatedLayoutMainIndexRoute
  '/_authenticated/_layout/_main/_centered/connect-device': typeof AuthenticatedLayoutMainCenteredConnectDeviceRoute
  '/_authenticated/_layout/_main/_centered/connect-hmd': typeof AuthenticatedLayoutMainCenteredConnectHmdRoute
  '/_authenticated/_layout/_main/_centered/flags': typeof AuthenticatedLayoutMainCenteredFlagsRoute
  '/_authenticated/_layout/_main/_centered/logout': typeof AuthenticatedLayoutMainCenteredLogoutRoute
  '/_authenticated/_layout/_main/apps/$appId': typeof AuthenticatedLayoutMainAppsAppIdRoute
  '/_authenticated/_layout/_main/_centered/install-client/': typeof AuthenticatedLayoutMainCenteredInstallClientIndexRoute
  '/_authenticated/_layout/_main/_centered/events/$eventId/rsvp': typeof AuthenticatedLayoutMainCenteredEventsEventIdRsvpRoute
  '/_authenticated/_layout/_main/_centered/install-client/$deviceSlug/{-$installationType}': typeof AuthenticatedLayoutMainCenteredInstallClientDeviceSlugChar123InstallationTypeChar125Route
  '/_authenticated/_layout/_main/groups/$groupId/apps/$appId': typeof AuthenticatedLayoutMainGroupsGroupIdAppsAppIdRoute
  '/_authenticated/_layout/_main/_centered/apps/$appId/launch/': typeof AuthenticatedLayoutMainCenteredAppsAppIdLaunchIndexRoute
  '/_authenticated/_layout/_main/_centered/apps/$appId/launch/$renderMode/$targetDeviceType': typeof AuthenticatedLayoutMainCenteredAppsAppIdLaunchRenderModeTargetDeviceTypeRoute
  '/_authenticated/_layout/_main/_centered/groups/$groupId/apps/$appId/launch/': typeof AuthenticatedLayoutMainCenteredGroupsGroupIdAppsAppIdLaunchIndexRoute
  '/_authenticated/_layout/_main/_centered/groups/$groupId/apps/$appId/launch/$renderMode/$targetDeviceType': typeof AuthenticatedLayoutMainCenteredGroupsGroupIdAppsAppIdLaunchRenderModeTargetDeviceTypeRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$'
    | '/server-location-wizard'
    | '/session'
    | '/legal'
    | '/login'
    | '/privacy'
    | '/terms'
    | '/session/remote-rendering-node-backchannel'
    | '/oauth2/callback'
    | '/session/'
    | '/connect-device'
    | '/connect-hmd'
    | '/flags'
    | '/logout'
    | '/apps/$appId'
    | '/install-client/'
    | '/events/$eventId/rsvp'
    | '/install-client/$deviceSlug/{-$installationType}'
    | '/groups/$groupId/apps/$appId'
    | '/apps/$appId/launch/'
    | '/apps/$appId/launch/$renderMode/$targetDeviceType'
    | '/groups/$groupId/apps/$appId/launch/'
    | '/groups/$groupId/apps/$appId/launch/$renderMode/$targetDeviceType'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$'
    | '/server-location-wizard'
    | '/legal'
    | '/login'
    | '/privacy'
    | '/terms'
    | '/session/remote-rendering-node-backchannel'
    | '/oauth2/callback'
    | '/session'
    | '/connect-device'
    | '/connect-hmd'
    | '/flags'
    | '/logout'
    | '/apps/$appId'
    | '/install-client'
    | '/events/$eventId/rsvp'
    | '/install-client/$deviceSlug/{-$installationType}'
    | '/groups/$groupId/apps/$appId'
    | '/apps/$appId/launch'
    | '/apps/$appId/launch/$renderMode/$targetDeviceType'
    | '/groups/$groupId/apps/$appId/launch'
    | '/groups/$groupId/apps/$appId/launch/$renderMode/$targetDeviceType'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_unauthenticated'
    | '/$'
    | '/server-location-wizard'
    | '/_authenticated/_layout'
    | '/_authenticated/session'
    | '/_unauthenticated/legal'
    | '/_unauthenticated/login'
    | '/_unauthenticated/privacy'
    | '/_unauthenticated/terms'
    | '/_authenticated/_layout/_main'
    | '/_authenticated/session/remote-rendering-node-backchannel'
    | '/_unauthenticated/oauth2/callback'
    | '/_authenticated/session/'
    | '/_authenticated/_layout/_main/_centered'
    | '/_authenticated/_layout/_main/'
    | '/_authenticated/_layout/_main/_centered/connect-device'
    | '/_authenticated/_layout/_main/_centered/connect-hmd'
    | '/_authenticated/_layout/_main/_centered/flags'
    | '/_authenticated/_layout/_main/_centered/logout'
    | '/_authenticated/_layout/_main/apps/$appId'
    | '/_authenticated/_layout/_main/_centered/install-client/'
    | '/_authenticated/_layout/_main/_centered/events/$eventId/rsvp'
    | '/_authenticated/_layout/_main/_centered/install-client/$deviceSlug/{-$installationType}'
    | '/_authenticated/_layout/_main/groups/$groupId/apps/$appId'
    | '/_authenticated/_layout/_main/_centered/apps/$appId/launch/'
    | '/_authenticated/_layout/_main/_centered/apps/$appId/launch/$renderMode/$targetDeviceType'
    | '/_authenticated/_layout/_main/_centered/groups/$groupId/apps/$appId/launch/'
    | '/_authenticated/_layout/_main/_centered/groups/$groupId/apps/$appId/launch/$renderMode/$targetDeviceType'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  UnauthenticatedRouteRoute: typeof UnauthenticatedRouteRouteWithChildren
  SplatRoute: typeof SplatRoute
  ServerLocationWizardRoute: typeof ServerLocationWizardRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_unauthenticated': {
      id: '/_unauthenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof UnauthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/server-location-wizard': {
      id: '/server-location-wizard'
      path: '/server-location-wizard'
      fullPath: '/server-location-wizard'
      preLoaderRoute: typeof ServerLocationWizardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/_layout': {
      id: '/_authenticated/_layout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedLayoutRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/session': {
      id: '/_authenticated/session'
      path: '/session'
      fullPath: '/session'
      preLoaderRoute: typeof AuthenticatedSessionRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_unauthenticated/legal': {
      id: '/_unauthenticated/legal'
      path: '/legal'
      fullPath: '/legal'
      preLoaderRoute: typeof UnauthenticatedLegalRouteImport
      parentRoute: typeof UnauthenticatedRouteRoute
    }
    '/_unauthenticated/login': {
      id: '/_unauthenticated/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof UnauthenticatedLoginRouteImport
      parentRoute: typeof UnauthenticatedRouteRoute
    }
    '/_unauthenticated/privacy': {
      id: '/_unauthenticated/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof UnauthenticatedPrivacyRouteImport
      parentRoute: typeof UnauthenticatedRouteRoute
    }
    '/_unauthenticated/terms': {
      id: '/_unauthenticated/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof UnauthenticatedTermsRouteImport
      parentRoute: typeof UnauthenticatedRouteRoute
    }
    '/_authenticated/_layout/_main': {
      id: '/_authenticated/_layout/_main'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedLayoutMainRouteRouteImport
      parentRoute: typeof AuthenticatedLayoutRouteRoute
    }
    '/_authenticated/session/': {
      id: '/_authenticated/session/'
      path: '/'
      fullPath: '/session/'
      preLoaderRoute: typeof AuthenticatedSessionIndexRouteImport
      parentRoute: typeof AuthenticatedSessionRouteRoute
    }
    '/_authenticated/session/remote-rendering-node-backchannel': {
      id: '/_authenticated/session/remote-rendering-node-backchannel'
      path: '/remote-rendering-node-backchannel'
      fullPath: '/session/remote-rendering-node-backchannel'
      preLoaderRoute: typeof AuthenticatedSessionRemoteRenderingNodeBackchannelRouteImport
      parentRoute: typeof AuthenticatedSessionRouteRoute
    }
    '/_unauthenticated/oauth2/callback': {
      id: '/_unauthenticated/oauth2/callback'
      path: '/oauth2/callback'
      fullPath: '/oauth2/callback'
      preLoaderRoute: typeof UnauthenticatedOauth2CallbackRouteImport
      parentRoute: typeof UnauthenticatedRouteRoute
    }
    '/_authenticated/_layout/_main/': {
      id: '/_authenticated/_layout/_main/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedLayoutMainIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutMainRouteRoute
    }
    '/_authenticated/_layout/_main/_centered': {
      id: '/_authenticated/_layout/_main/_centered'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedLayoutMainCenteredRouteRouteImport
      parentRoute: typeof AuthenticatedLayoutMainRouteRoute
    }
    '/_authenticated/_layout/_main/_centered/connect-device': {
      id: '/_authenticated/_layout/_main/_centered/connect-device'
      path: '/connect-device'
      fullPath: '/connect-device'
      preLoaderRoute: typeof AuthenticatedLayoutMainCenteredConnectDeviceRouteImport
      parentRoute: typeof AuthenticatedLayoutMainCenteredRouteRoute
    }
    '/_authenticated/_layout/_main/_centered/connect-hmd': {
      id: '/_authenticated/_layout/_main/_centered/connect-hmd'
      path: '/connect-hmd'
      fullPath: '/connect-hmd'
      preLoaderRoute: typeof AuthenticatedLayoutMainCenteredConnectHmdRouteImport
      parentRoute: typeof AuthenticatedLayoutMainCenteredRouteRoute
    }
    '/_authenticated/_layout/_main/_centered/flags': {
      id: '/_authenticated/_layout/_main/_centered/flags'
      path: '/flags'
      fullPath: '/flags'
      preLoaderRoute: typeof AuthenticatedLayoutMainCenteredFlagsRouteImport
      parentRoute: typeof AuthenticatedLayoutMainCenteredRouteRoute
    }
    '/_authenticated/_layout/_main/_centered/logout': {
      id: '/_authenticated/_layout/_main/_centered/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof AuthenticatedLayoutMainCenteredLogoutRouteImport
      parentRoute: typeof AuthenticatedLayoutMainCenteredRouteRoute
    }
    '/_authenticated/_layout/_main/apps/$appId': {
      id: '/_authenticated/_layout/_main/apps/$appId'
      path: '/apps/$appId'
      fullPath: '/apps/$appId'
      preLoaderRoute: typeof AuthenticatedLayoutMainAppsAppIdRouteImport
      parentRoute: typeof AuthenticatedLayoutMainRouteRoute
    }
    '/_authenticated/_layout/_main/_centered/install-client/': {
      id: '/_authenticated/_layout/_main/_centered/install-client/'
      path: '/install-client'
      fullPath: '/install-client/'
      preLoaderRoute: typeof AuthenticatedLayoutMainCenteredInstallClientIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutMainCenteredRouteRoute
    }
    '/_authenticated/_layout/_main/_centered/events/$eventId/rsvp': {
      id: '/_authenticated/_layout/_main/_centered/events/$eventId/rsvp'
      path: '/events/$eventId/rsvp'
      fullPath: '/events/$eventId/rsvp'
      preLoaderRoute: typeof AuthenticatedLayoutMainCenteredEventsEventIdRsvpRouteImport
      parentRoute: typeof AuthenticatedLayoutMainCenteredRouteRoute
    }
    '/_authenticated/_layout/_main/_centered/install-client/$deviceSlug/{-$installationType}': {
      id: '/_authenticated/_layout/_main/_centered/install-client/$deviceSlug/{-$installationType}'
      path: '/install-client/$deviceSlug/{-$installationType}'
      fullPath: '/install-client/$deviceSlug/{-$installationType}'
      preLoaderRoute: typeof AuthenticatedLayoutMainCenteredInstallClientDeviceSlugChar123InstallationTypeChar125RouteImport
      parentRoute: typeof AuthenticatedLayoutMainCenteredRouteRoute
    }
    '/_authenticated/_layout/_main/groups/$groupId/apps/$appId': {
      id: '/_authenticated/_layout/_main/groups/$groupId/apps/$appId'
      path: '/groups/$groupId/apps/$appId'
      fullPath: '/groups/$groupId/apps/$appId'
      preLoaderRoute: typeof AuthenticatedLayoutMainGroupsGroupIdAppsAppIdRouteImport
      parentRoute: typeof AuthenticatedLayoutMainRouteRoute
    }
    '/_authenticated/_layout/_main/_centered/apps/$appId/launch/': {
      id: '/_authenticated/_layout/_main/_centered/apps/$appId/launch/'
      path: '/apps/$appId/launch'
      fullPath: '/apps/$appId/launch/'
      preLoaderRoute: typeof AuthenticatedLayoutMainCenteredAppsAppIdLaunchIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutMainCenteredRouteRoute
    }
    '/_authenticated/_layout/_main/_centered/apps/$appId/launch/$renderMode/$targetDeviceType': {
      id: '/_authenticated/_layout/_main/_centered/apps/$appId/launch/$renderMode/$targetDeviceType'
      path: '/apps/$appId/launch/$renderMode/$targetDeviceType'
      fullPath: '/apps/$appId/launch/$renderMode/$targetDeviceType'
      preLoaderRoute: typeof AuthenticatedLayoutMainCenteredAppsAppIdLaunchRenderModeTargetDeviceTypeRouteImport
      parentRoute: typeof AuthenticatedLayoutMainCenteredRouteRoute
    }
    '/_authenticated/_layout/_main/_centered/groups/$groupId/apps/$appId/launch/': {
      id: '/_authenticated/_layout/_main/_centered/groups/$groupId/apps/$appId/launch/'
      path: '/groups/$groupId/apps/$appId/launch'
      fullPath: '/groups/$groupId/apps/$appId/launch/'
      preLoaderRoute: typeof AuthenticatedLayoutMainCenteredGroupsGroupIdAppsAppIdLaunchIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutMainCenteredRouteRoute
    }
    '/_authenticated/_layout/_main/_centered/groups/$groupId/apps/$appId/launch/$renderMode/$targetDeviceType': {
      id: '/_authenticated/_layout/_main/_centered/groups/$groupId/apps/$appId/launch/$renderMode/$targetDeviceType'
      path: '/groups/$groupId/apps/$appId/launch/$renderMode/$targetDeviceType'
      fullPath: '/groups/$groupId/apps/$appId/launch/$renderMode/$targetDeviceType'
      preLoaderRoute: typeof AuthenticatedLayoutMainCenteredGroupsGroupIdAppsAppIdLaunchRenderModeTargetDeviceTypeRouteImport
      parentRoute: typeof AuthenticatedLayoutMainCenteredRouteRoute
    }
  }
}

interface AuthenticatedLayoutMainCenteredRouteRouteChildren {
  AuthenticatedLayoutMainCenteredConnectDeviceRoute: typeof AuthenticatedLayoutMainCenteredConnectDeviceRoute
  AuthenticatedLayoutMainCenteredConnectHmdRoute: typeof AuthenticatedLayoutMainCenteredConnectHmdRoute
  AuthenticatedLayoutMainCenteredFlagsRoute: typeof AuthenticatedLayoutMainCenteredFlagsRoute
  AuthenticatedLayoutMainCenteredLogoutRoute: typeof AuthenticatedLayoutMainCenteredLogoutRoute
  AuthenticatedLayoutMainCenteredInstallClientIndexRoute: typeof AuthenticatedLayoutMainCenteredInstallClientIndexRoute
  AuthenticatedLayoutMainCenteredEventsEventIdRsvpRoute: typeof AuthenticatedLayoutMainCenteredEventsEventIdRsvpRoute
  AuthenticatedLayoutMainCenteredInstallClientDeviceSlugChar123InstallationTypeChar125Route: typeof AuthenticatedLayoutMainCenteredInstallClientDeviceSlugChar123InstallationTypeChar125Route
  AuthenticatedLayoutMainCenteredAppsAppIdLaunchIndexRoute: typeof AuthenticatedLayoutMainCenteredAppsAppIdLaunchIndexRoute
  AuthenticatedLayoutMainCenteredAppsAppIdLaunchRenderModeTargetDeviceTypeRoute: typeof AuthenticatedLayoutMainCenteredAppsAppIdLaunchRenderModeTargetDeviceTypeRoute
  AuthenticatedLayoutMainCenteredGroupsGroupIdAppsAppIdLaunchIndexRoute: typeof AuthenticatedLayoutMainCenteredGroupsGroupIdAppsAppIdLaunchIndexRoute
  AuthenticatedLayoutMainCenteredGroupsGroupIdAppsAppIdLaunchRenderModeTargetDeviceTypeRoute: typeof AuthenticatedLayoutMainCenteredGroupsGroupIdAppsAppIdLaunchRenderModeTargetDeviceTypeRoute
}

const AuthenticatedLayoutMainCenteredRouteRouteChildren: AuthenticatedLayoutMainCenteredRouteRouteChildren =
  {
    AuthenticatedLayoutMainCenteredConnectDeviceRoute:
      AuthenticatedLayoutMainCenteredConnectDeviceRoute,
    AuthenticatedLayoutMainCenteredConnectHmdRoute:
      AuthenticatedLayoutMainCenteredConnectHmdRoute,
    AuthenticatedLayoutMainCenteredFlagsRoute:
      AuthenticatedLayoutMainCenteredFlagsRoute,
    AuthenticatedLayoutMainCenteredLogoutRoute:
      AuthenticatedLayoutMainCenteredLogoutRoute,
    AuthenticatedLayoutMainCenteredInstallClientIndexRoute:
      AuthenticatedLayoutMainCenteredInstallClientIndexRoute,
    AuthenticatedLayoutMainCenteredEventsEventIdRsvpRoute:
      AuthenticatedLayoutMainCenteredEventsEventIdRsvpRoute,
    AuthenticatedLayoutMainCenteredInstallClientDeviceSlugChar123InstallationTypeChar125Route:
      AuthenticatedLayoutMainCenteredInstallClientDeviceSlugChar123InstallationTypeChar125Route,
    AuthenticatedLayoutMainCenteredAppsAppIdLaunchIndexRoute:
      AuthenticatedLayoutMainCenteredAppsAppIdLaunchIndexRoute,
    AuthenticatedLayoutMainCenteredAppsAppIdLaunchRenderModeTargetDeviceTypeRoute:
      AuthenticatedLayoutMainCenteredAppsAppIdLaunchRenderModeTargetDeviceTypeRoute,
    AuthenticatedLayoutMainCenteredGroupsGroupIdAppsAppIdLaunchIndexRoute:
      AuthenticatedLayoutMainCenteredGroupsGroupIdAppsAppIdLaunchIndexRoute,
    AuthenticatedLayoutMainCenteredGroupsGroupIdAppsAppIdLaunchRenderModeTargetDeviceTypeRoute:
      AuthenticatedLayoutMainCenteredGroupsGroupIdAppsAppIdLaunchRenderModeTargetDeviceTypeRoute,
  }

const AuthenticatedLayoutMainCenteredRouteRouteWithChildren =
  AuthenticatedLayoutMainCenteredRouteRoute._addFileChildren(
    AuthenticatedLayoutMainCenteredRouteRouteChildren,
  )

interface AuthenticatedLayoutMainRouteRouteChildren {
  AuthenticatedLayoutMainCenteredRouteRoute: typeof AuthenticatedLayoutMainCenteredRouteRouteWithChildren
  AuthenticatedLayoutMainIndexRoute: typeof AuthenticatedLayoutMainIndexRoute
  AuthenticatedLayoutMainAppsAppIdRoute: typeof AuthenticatedLayoutMainAppsAppIdRoute
  AuthenticatedLayoutMainGroupsGroupIdAppsAppIdRoute: typeof AuthenticatedLayoutMainGroupsGroupIdAppsAppIdRoute
}

const AuthenticatedLayoutMainRouteRouteChildren: AuthenticatedLayoutMainRouteRouteChildren =
  {
    AuthenticatedLayoutMainCenteredRouteRoute:
      AuthenticatedLayoutMainCenteredRouteRouteWithChildren,
    AuthenticatedLayoutMainIndexRoute: AuthenticatedLayoutMainIndexRoute,
    AuthenticatedLayoutMainAppsAppIdRoute:
      AuthenticatedLayoutMainAppsAppIdRoute,
    AuthenticatedLayoutMainGroupsGroupIdAppsAppIdRoute:
      AuthenticatedLayoutMainGroupsGroupIdAppsAppIdRoute,
  }

const AuthenticatedLayoutMainRouteRouteWithChildren =
  AuthenticatedLayoutMainRouteRoute._addFileChildren(
    AuthenticatedLayoutMainRouteRouteChildren,
  )

interface AuthenticatedLayoutRouteRouteChildren {
  AuthenticatedLayoutMainRouteRoute: typeof AuthenticatedLayoutMainRouteRouteWithChildren
}

const AuthenticatedLayoutRouteRouteChildren: AuthenticatedLayoutRouteRouteChildren =
  {
    AuthenticatedLayoutMainRouteRoute:
      AuthenticatedLayoutMainRouteRouteWithChildren,
  }

const AuthenticatedLayoutRouteRouteWithChildren =
  AuthenticatedLayoutRouteRoute._addFileChildren(
    AuthenticatedLayoutRouteRouteChildren,
  )

interface AuthenticatedSessionRouteRouteChildren {
  AuthenticatedSessionRemoteRenderingNodeBackchannelRoute: typeof AuthenticatedSessionRemoteRenderingNodeBackchannelRoute
  AuthenticatedSessionIndexRoute: typeof AuthenticatedSessionIndexRoute
}

const AuthenticatedSessionRouteRouteChildren: AuthenticatedSessionRouteRouteChildren =
  {
    AuthenticatedSessionRemoteRenderingNodeBackchannelRoute:
      AuthenticatedSessionRemoteRenderingNodeBackchannelRoute,
    AuthenticatedSessionIndexRoute: AuthenticatedSessionIndexRoute,
  }

const AuthenticatedSessionRouteRouteWithChildren =
  AuthenticatedSessionRouteRoute._addFileChildren(
    AuthenticatedSessionRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedLayoutRouteRoute: typeof AuthenticatedLayoutRouteRouteWithChildren
  AuthenticatedSessionRouteRoute: typeof AuthenticatedSessionRouteRouteWithChildren
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedLayoutRouteRoute: AuthenticatedLayoutRouteRouteWithChildren,
  AuthenticatedSessionRouteRoute: AuthenticatedSessionRouteRouteWithChildren,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

interface UnauthenticatedRouteRouteChildren {
  UnauthenticatedLegalRoute: typeof UnauthenticatedLegalRoute
  UnauthenticatedLoginRoute: typeof UnauthenticatedLoginRoute
  UnauthenticatedPrivacyRoute: typeof UnauthenticatedPrivacyRoute
  UnauthenticatedTermsRoute: typeof UnauthenticatedTermsRoute
  UnauthenticatedOauth2CallbackRoute: typeof UnauthenticatedOauth2CallbackRoute
}

const UnauthenticatedRouteRouteChildren: UnauthenticatedRouteRouteChildren = {
  UnauthenticatedLegalRoute: UnauthenticatedLegalRoute,
  UnauthenticatedLoginRoute: UnauthenticatedLoginRoute,
  UnauthenticatedPrivacyRoute: UnauthenticatedPrivacyRoute,
  UnauthenticatedTermsRoute: UnauthenticatedTermsRoute,
  UnauthenticatedOauth2CallbackRoute: UnauthenticatedOauth2CallbackRoute,
}

const UnauthenticatedRouteRouteWithChildren =
  UnauthenticatedRouteRoute._addFileChildren(UnauthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  UnauthenticatedRouteRoute: UnauthenticatedRouteRouteWithChildren,
  SplatRoute: SplatRoute,
  ServerLocationWizardRoute: ServerLocationWizardRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
